import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "terms", "submitButton"]

  connect() {
    this.validate()
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return

    const allFieldsFilled = this.fieldTargets.every((field) => field.value.trim().length > 0)
    const termsAccepted = this.hasTermsTarget && this.termsTarget.checked

    this.submitButtonTarget.disabled = !(allFieldsFilled && termsAccepted)
  }
}
